import req from "../http";

const frontPage = {
  // 取得 輪播(分頁)
  getCarouselPaging(params) {
    return req("get", "/FrontPageBanner/paging", params);
  },

  // 新增 輪播
  postCarousel(params) {
    return req("post", "/FrontPageBanner", params);
  },

  // 編輯 輪播
  putCarousel(params) {
    return req("put", "/FrontPageBanner", params);
  },

  // 排序 輪播
  sortCarousel(params) {
    return req("post", "/FrontPageBanner/sort", params);
  },

  // 刪除 輪播
  deleteCarousel(guid) {
    return req("delete", `/FrontPageBanner/delete/${guid}`);
  },

  //////////////////////////////////////////////////////////////////////////////////////

  // 取得 公司簡介(分頁)
  getCompanyProfilePaging(params) {
    return req("get", "/CompanyProfile/paging", params);
  },

  // 新增 公司簡介
  postBlock(params) {
    return req("post", "/CompanyProfile", params);
  },

  // 編輯 公司簡介
  putBlock(params) {
    return req("put", "/CompanyProfile", params);
  },

  // 刪除 公司簡介
  deleteCompanyProfile(guid) {
    return req("delete", `/CompanyProfile/delete/${guid}`);
  },

  // 排序 公司簡介
  sortCompanyProfile(params) {
    return req("post", "/CompanyProfile/sort", params);
  },
};

export default frontPage;